module.exports = __webpack_public_path__ + "img/collectMaintainIcon.ca8acc5f.png";